var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"px-4 py-6"},[_c('v-skeleton-loader',{attrs:{"type":"table"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }